// BFSG
import * as React from 'react'
import styled from 'styled-components'
import { Product } from 'modules/listing/types'
import theme from 'theme'
import genProductImageUrl from 'utils/genProductImageUrl'
import Description from './Description'
import BuyBox from './BuyBox'
import Flags from 'theme/molecules/Flags'
import Link from 'theme/atoms/Link'
import * as evt from './events'
import useInView from 'hooks/useInView'
import getProductLink from 'utils/getProductLink'
import useTranslations from 'hooks/useTranslations'

type Props = {
  hit: Product
  listname: string
  listPosition: number
  listid: string
  evtSource?: string
  'data-cy-handle'?: string
}

export default function ProductWidgetSeries(props: Props) {
  const [ref, isInView] = useInView(-200, true)
  const t = useTranslations<'templates-Series'>()

  React.useEffect(() => {
    if (!isInView) return
    evt.scrollIntoView(
      props.hit,
      props.listname,
      props.listPosition,
      props.listid
    )
  }, [isInView, props.hit, props.listname, props.listPosition, props.listid])

  return (
    <Wrapper
      className="ProductWidgetSeries"
      data-cy-ctx="molecules/ProductWidgetSeries"
    >
      <div className="img-wrapper">
        <Flags type="widget" product={props.hit} />
        <Link
          className="detail-link"
          ref={ref}
          to={getProductLink(props.hit)}
          aria-label={t.asText(false, 'sku_detail_link')}
          onClick={() =>
            evt.skuWidgetClick(
              props.hit,
              props.listname,
              props.listPosition,
              props.listid
            )
          }
          data-cy-handle={props['data-cy-handle']}
        >
          <img src={genProductImageUrl(props.hit.images.imageWeb[0], 's')} />
        </Link>
      </div>

      <Description
        hit={props.hit}
        listname={props.listname}
        listPosition={props.listPosition}
        listid={props.listid}
        evtSource={props.evtSource}
      />

      <BuyBox
        hit={props.hit}
        listname={props.listname}
        listPosition={props.listPosition}
        listid={props.listid}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
  border-bottom: 1px solid ${theme.colors.shade.b6};
  padding-bottom: ${theme.spacing('ml')};

  grid:
    'ImgWrapper Description'
    '    .      Description'
    'BuyBox     BuyBox'
    / 4fr 6fr;
  grid-column-gap: ${theme.spacing('s')};
  grid-row-gap: ${theme.spacing('m')};

  > .img-wrapper {
    min-width: 5rem;
    grid-area: ImgWrapper;
    position: relative;
    > a > img {
      width: 100%;
    }

    > .Flags {
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  > .Description {
    grid-area: Description;
  }
  > .BuyBox {
    grid-area: BuyBox;
  }

  @media (min-width: ${theme.ms.LG}px) {
    grid:
      'ImgWrapper Description BuyBox'
      / 160px 1fr 400px;
    grid-column-gap: ${theme.spacing('ml')};
  }
`
